<p-skeleton [width]="width" [height]="height" *ngIf="isLoading"></p-skeleton>
<img
  [src]="imageSrc"
  [alt]="alt"
  [hidden]="isLoading"
  (load)="hideLoader()"
  [ngStyle]="{ height: height, width: width }"
/>
